module.exports = __webpack_public_path__ + "img/Tessellate45.dd167d70.jpg";